import { ProjectElementType } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, list, range }) =>
    present(
      repository
        .saveList(project, list)
        .then((savedList) =>
          (range
            ? repository.moveProjectElement(
                savedList.uuid,
                ProjectElementType.LIST,
                list.parentList ?? { ...list, uuid: "" },
                range,
                false,
              )
            : Promise.resolve()
          ).then(() => ({ project, list: savedList, range })),
        )
        .catch((error) => Promise.reject({ error, project, list, range })),
    );
}

export type { Interactor };

export { createInteractor };
